<template>
    <div class="section-box received-payment">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-button size="mini" :class="form.isInvoiced ==0 ?'selected':''" @click="titleClick(0)">未开票</el-button>
                <el-button size="mini" style="margin-left: 25px;" @click="titleClick(1)" :class="form.isInvoiced ==1 ?'selected':''">已开票</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="单号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.orderNo" placeholder="输入关键字搜索" @blur="handleSearch()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.orderNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单/订单名称" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.orderName" placeholder="输入关键字搜索" @blur="handleSearch()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.orderName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.senderName" placeholder="输入关键字搜索" @blur="handleSearch()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.senderName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="平台" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.orderSource" placeholder="请选择平台" style="width: 100%;" @change="handleSearch()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.key" :label="item.value" v-for="(item, index) in orderSourceOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.orderSourceStr || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单Code" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.senderCode" placeholder="输入关键字搜索" @blur="handleSearch()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.senderCode || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="已收金额" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.senderMoneyBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.senderMoneyEnd" style="width: 45%;" placeholder="搜索" @blur="handleSearch()" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.senderMoney}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="备注" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.remark" placeholder="输入关键字搜索" @blur="handleSearch()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.remark || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="支付时间" >
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.EffectivityTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                            @change="handleSearch()"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.finishDt || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-if="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// DOTO：静态展示数据 对接的时候可以删掉
import { PERIOD } from '@/config/const/common.js'
// End
import { 
  getStorageToken,
} from '@/utils/store'
import {
    receivedList,orderSourceOption,
} from "@/service/payApi";
  export default {
    data() {
        return {
            PERIOD,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,

                EffectivityTime: [],    //时间
                isInvoiced:0,
                orderName:'',
                orderNo:'',
                orderSource:'',
                remark:'',
                senderCode:'',
                senderMoneyBegin:'',
                senderMoneyEnd:'',
                senderName:'',
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            orderSourceOptionArr:[],
        }
    },
    activated(){
        this.handleSearch()
        this.getOrderSourceOption()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        getOrderSourceOption(){
                orderSourceOption().then((r)=>{
                    if(r.Result != 1){
                        return this.$message.error(r.Message)
                    }
                    this.orderSourceOptionArr = r.Data
                })
            },
        downloadFile() {
            const _this = this
            let data = {
                isInvoiced:this.form.isInvoiced,
            }
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.finishDtBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.finishDtEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.finishDtBegin) delete data.finishDtBegin;
                    if (data.finishDtEnd) delete data.finishDtEnd;
                }
            if(this.form.orderName) data.orderName = this.form.orderName
            if(this.form.orderNo) data.orderNo = this.form.orderNo
            if(this.form.orderSource) data.orderSource = this.form.orderSource
            if(this.form.remark) data.remark = this.form.remark
            if(this.form.senderCode) data.senderCode = this.form.senderCode
            if(this.form.senderMoneyBegin) data.senderMoneyBegin = this.form.senderMoneyBegin
            if(this.form.senderMoneyEnd) data.senderMoneyEnd = this.form.senderMoneyEnd
            if(this.form.senderName) data.senderName = this.form.senderName

            let url =
            process.env.NODE_ENV == "development" ?
            "/api2" :
            process.env.VUE_APP_API2;

            window.open(
            url + "/gz/admin/download/fundYet/download" + "?" + this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
            Object.keys(json).map(function (key) {
                if (json[key] === undefined) return "";
                return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
            })
            ).join("&");
        },
        cleanArray(actual) {
        var newArray = [];
        for (var i = 0; i < actual.length; i++) {
          if (actual[i]) {
            newArray.push(actual[i]);
          }
        }
        return newArray;
      },
        titleClick(type){
            this.form.isInvoiced = type;this.form.PageNo=1;this.form.PageSize=10
            this.handleSearch()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.GetCouponsList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetCouponsList()
        },
        async GetCouponsList(){
            const _this = this;
            this.listLoading = true
            let data = {
                pageNum:this.form.PageNo,
                pageSize:this.form.PageSize,   
                rational:true,
                isInvoiced:this.form.isInvoiced,
            }
            data.Token = getStorageToken();
            data.platform = 'zyd'
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.finishDtBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.finishDtEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.finishDtBegin) delete data.finishDtBegin;
                    if (data.finishDtEnd) delete data.finishDtEnd;
                }
            if(this.form.orderName) data.orderName = this.form.orderName
            if(this.form.orderNo) data.orderNo = this.form.orderNo
            if(this.form.orderSource) data.orderSource = this.form.orderSource
            if(this.form.remark) data.remark = this.form.remark
            if(this.form.senderCode) data.senderCode = this.form.senderCode
            if(this.form.senderMoneyBegin) data.senderMoneyBegin = this.form.senderMoneyBegin
            if(this.form.senderMoneyEnd) data.senderMoneyEnd = this.form.senderMoneyEnd
            if(this.form.senderName) data.senderName = this.form.senderName

            let res = await receivedList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.datas
            this.total = res.Data.total
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .received-payment {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>